"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var react_1 = __importDefault(require("react"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var icon_config_1 = require("../../configs/icon.config");
require("./icon.css");
var Icon = function (props) {
    var _a, _b;
    // get the svg or custom icon utility
    var getIcon = function (icon, definitions) {
        if (definitions === void 0) { definitions = icon_config_1.FAIconDefinitions; }
        return definitions[icon];
    };
    var sharedProps = {
        className: props.size + ' ' + props.className,
        'aria-label': props.icon.toLowerCase(),
    };
    var iconElement;
    // check to see if it is a Font Awesome icon
    if (!!getIcon(props.icon)) {
        iconElement = (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, __assign({ icon: getIcon(props.icon) }, sharedProps), props.children));
    }
    else {
        var CustomIcon = getIcon(props.icon, icon_config_1.CustomIconDefinitions);
        iconElement = react_1.default.createElement(CustomIcon, __assign({}, sharedProps), props.children);
    }
    var toClassString = function (str) { return str.toLowerCase().replace('_', '-'); };
    var classes = [
        'il-icon',
        toClassString(props.icon),
        props.containerClassName,
    ];
    return (react_1.default.createElement(Box_1.default, { 'data-testid': (_a = props.dataTestId) !== null && _a !== void 0 ? _a : 'il-icon-test-id',
        container: (_b = props.container) !== null && _b !== void 0 ? _b : 'span',
        className: classes.join(' '),
        sx: __assign({ display: 'inline-block', '& svg': {
                width: '2em',
                height: '2em',
            } }, props.sx) }, iconElement));
};
exports.Icon = Icon;
